import styled from '@emotion/styled';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import React, { useId } from 'react';
import { breakpoints, getMQ } from 'src/helpers';
import colors from 'src/styles/colors';

type StyledSignUpButtonProps = {
  inverted?: boolean;
  borderColor?: 'blue' | 'white';
};

const StyledSignUpButton = styled.button<StyledSignUpButtonProps>`
  padding: 12px 25px;
  background: ${(props) => (props.inverted ? colors.darkBlue : colors.secondaryBackground)};
  border-radius: 48px;
  border: 0;
  color: ${(props) => (props.inverted ? '#fff' : colors.darkBlue)};
  font-weight: bold;
  font-size: 14px;
  display: flex;
  cursor: pointer;
  transition: all 0.5s;
  border: 4px solid rgba(255, 255, 255, 0.6);
  border: ${(props) => (props.borderColor === 'blue' ? `4px solid ${colors.darkBlue}` : `4px solid ${colors.white}`)};
  align-items: center;
  justify-content: space-between;
  height: 48px;
  min-width: 200px;
  align-self: center;

  &:hover {
    background: ${(props) => (props.inverted ? colors.lightBackground : colors.darkBlue)};
    border-color: ${(props) =>
      props.borderColor === 'white' ? colors.white : props.inverted ? colors.darkBlue : '#fff'};
    color: ${(props) => (props.inverted ? colors.darkBlue : '#fff')};
  }

  ${getMQ(breakpoints.m)} {
    font-size: 16px;
  }
`;

export const StyledSignUpButtonTitle = styled.p`
  margin: 0px;
  margin-inline-end: 15px;
`;

interface SignUpButtonProps {
  title: string;
  id?: string;
  borderColor?: 'blue' | 'white';
  onClick?: () => void;
  inverted?: boolean;
  style?: any;
}

const SignUpButton = ({ id, title, onClick, borderColor, inverted, style }: SignUpButtonProps) => {
  const signupButtonId = useId();
  return (
    <StyledSignUpButton
      id={id || `${signupButtonId}-button`}
      data-testid={id || 'signup-button'}
      borderColor={borderColor}
      onClick={onClick}
      inverted={inverted}
      style={style}>
      <StyledSignUpButtonTitle>{title}</StyledSignUpButtonTitle>
      <ArrowBackIosIcon sx={{ fontSize: 22 }} />
    </StyledSignUpButton>
  );
};

export default SignUpButton;
